import {getStore} from 'redux-stores/Store';

/**
 * When called with await, this function will wait until the next redux action
 * is dispatched. Intended to be used for subscribing to generic activity from
 * the redux store, when you want to be notified when the next event of any type
 * happens, but don't really care which type of event it is.
 */
export default function nextReduxAction(): Promise<void> {
  return new Promise((resolve, reject) => {
    const unsubscribe = getStore().subscribe(() => {
      unsubscribe();
      resolve();
    });
  });
}
